import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
}), 'Details');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Details.js
// module id = 3113
// module chunks = 2